(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6210],{

/***/ 65582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Container_Container; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/capitalize/capitalize.js
var capitalize = __webpack_require__(14142);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useThemeProps/useThemeProps.js
var useThemeProps = __webpack_require__(29628);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js + 1 modules
var styled = __webpack_require__(45098);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createTheme/createTheme.js + 2 modules
var createTheme = __webpack_require__(17172);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/Container/createContainer.js


const _excluded = ["className", "component", "disableGutters", "fixed", "maxWidth", "classes"];










const defaultTheme = (0,createTheme/* default */.Z)();
const defaultCreateStyledComponent = (0,styled/* default */.Z)('div', {
  name: 'MuiContainer',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`maxWidth${(0,capitalize/* default */.Z)(String(ownerState.maxWidth))}`], ownerState.fixed && styles.fixed, ownerState.disableGutters && styles.disableGutters];
  }
});
const useThemePropsDefault = inProps => (0,useThemeProps/* default */.Z)({
  props: inProps,
  name: 'MuiContainer',
  defaultTheme
});
const useUtilityClasses = (ownerState, componentName) => {
  const getContainerUtilityClass = slot => {
    return (0,generateUtilityClass/* default */.ZP)(componentName, slot);
  };
  const {
    classes,
    fixed,
    disableGutters,
    maxWidth
  } = ownerState;
  const slots = {
    root: ['root', maxWidth && `maxWidth${(0,capitalize/* default */.Z)(String(maxWidth))}`, fixed && 'fixed', disableGutters && 'disableGutters']
  };
  return (0,composeClasses/* default */.Z)(slots, getContainerUtilityClass, classes);
};
function createContainer(options = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent,
    useThemeProps = useThemePropsDefault,
    componentName = 'MuiContainer'
  } = options;
  const ContainerRoot = createStyledComponent(({
    theme,
    ownerState
  }) => (0,esm_extends/* default */.Z)({
    width: '100%',
    marginLeft: 'auto',
    boxSizing: 'border-box',
    marginRight: 'auto',
    display: 'block'
  }, !ownerState.disableGutters && {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }
  }), ({
    theme,
    ownerState
  }) => ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey) => {
    const breakpoint = breakpointValueKey;
    const value = theme.breakpoints.values[breakpoint];
    if (value !== 0) {
      // @ts-ignore
      acc[theme.breakpoints.up(breakpoint)] = {
        maxWidth: `${value}${theme.breakpoints.unit}`
      };
    }
    return acc;
  }, {}), ({
    theme,
    ownerState
  }) => (0,esm_extends/* default */.Z)({}, ownerState.maxWidth === 'xs' && {
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [theme.breakpoints.up('xs')]: {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }
  }, ownerState.maxWidth &&
  // @ts-ignore module augmentation fails if custom breakpoints are used
  ownerState.maxWidth !== 'xs' && {
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [theme.breakpoints.up(ownerState.maxWidth)]: {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
    }
  }));
  const Container = /*#__PURE__*/react.forwardRef(function Container(inProps, ref) {
    const props = useThemeProps(inProps);
    const {
        className,
        component = 'div',
        disableGutters = false,
        fixed = false,
        maxWidth = 'lg'
      } = props,
      other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
    const ownerState = (0,esm_extends/* default */.Z)({}, props, {
      component,
      disableGutters,
      fixed,
      maxWidth
    });

    // @ts-ignore module augmentation fails if custom breakpoints are used
    const classes = useUtilityClasses(ownerState, componentName);
    return (
      /*#__PURE__*/
      // @ts-ignore theme is injected by the styled util
      (0,jsx_runtime.jsx)(ContainerRoot, (0,esm_extends/* default */.Z)({
        as: component
        // @ts-ignore module augmentation fails if custom breakpoints are used
        ,
        ownerState: ownerState,
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        ref: ref
      }, other))
    );
  });
   false ? 0 : void 0;
  return Container;
}
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var utils_capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styles_styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Container/Container.js
'use client';






const Container = createContainer({
  createStyledComponent: (0,styles_styled/* default */.ZP)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles) => {
      const {
        ownerState
      } = props;
      return [styles.root, styles[`maxWidth${(0,utils_capitalize/* default */.Z)(String(ownerState.maxWidth))}`], ownerState.fixed && styles.fixed, ownerState.disableGutters && styles.disableGutters];
    }
  }),
  useThemeProps: inProps => (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiContainer'
  })
});
 false ? 0 : void 0;
/* harmony default export */ var Container_Container = (Container);

/***/ }),

/***/ 45098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_styled; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/index.js + 4 modules
var styled_engine = __webpack_require__(63390);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/deepmerge/deepmerge.js
var deepmerge = __webpack_require__(4953);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createTheme/createTheme.js + 2 modules
var createTheme = __webpack_require__(17172);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx = __webpack_require__(86523);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createStyled.js


const _excluded = ["ownerState"],
  _excluded2 = ["variants"],
  _excluded3 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
/* eslint-disable no-underscore-dangle */






function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}

// Update /system/styled/#api in case if this changes
function shouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const systemDefaultTheme = (0,createTheme/* default */.Z)();
const lowercaseFirstLetter = string => {
  if (!string) {
    return string;
  }
  return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme({
  defaultTheme,
  theme,
  themeId
}) {
  return isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function defaultOverridesResolver(slot) {
  if (!slot) {
    return null;
  }
  return (props, styles) => styles[slot];
}
function processStyleArg(callableStyle, _ref) {
  let {
      ownerState
    } = _ref,
    props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, _excluded);
  const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0,esm_extends/* default */.Z)({
    ownerState
  }, props)) : callableStyle;
  if (Array.isArray(resolvedStylesArg)) {
    return resolvedStylesArg.flatMap(resolvedStyle => processStyleArg(resolvedStyle, (0,esm_extends/* default */.Z)({
      ownerState
    }, props)));
  }
  if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
    const {
        variants = []
      } = resolvedStylesArg,
      otherStyles = (0,objectWithoutPropertiesLoose/* default */.Z)(resolvedStylesArg, _excluded2);
    let result = otherStyles;
    variants.forEach(variant => {
      let isMatch = true;
      if (typeof variant.props === 'function') {
        isMatch = variant.props((0,esm_extends/* default */.Z)({
          ownerState
        }, props, ownerState));
      } else {
        Object.keys(variant.props).forEach(key => {
          if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) {
            isMatch = false;
          }
        });
      }
      if (isMatch) {
        if (!Array.isArray(result)) {
          result = [result];
        }
        result.push(typeof variant.style === 'function' ? variant.style((0,esm_extends/* default */.Z)({
          ownerState
        }, props, ownerState)) : variant.style);
      }
    });
    return result;
  }
  return resolvedStylesArg;
}
function createStyled(input = {}) {
  const {
    themeId,
    defaultTheme = systemDefaultTheme,
    rootShouldForwardProp = shouldForwardProp,
    slotShouldForwardProp = shouldForwardProp
  } = input;
  const systemSx = props => {
    return (0,styleFunctionSx/* default */.Z)((0,esm_extends/* default */.Z)({}, props, {
      theme: resolveTheme((0,esm_extends/* default */.Z)({}, props, {
        defaultTheme,
        themeId
      }))
    }));
  };
  systemSx.__mui_systemSx = true;
  return (tag, inputOptions = {}) => {
    // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
    (0,styled_engine.internal_processStyles)(tag, styles => styles.filter(style => !(style != null && style.__mui_systemSx)));
    const {
        name: componentName,
        slot: componentSlot,
        skipVariantsResolver: inputSkipVariantsResolver,
        skipSx: inputSkipSx,
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot))
      } = inputOptions,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(inputOptions, _excluded3);

    // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
    const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver :
    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
    const skipSx = inputSkipSx || false;
    let label;
    if (false) {}
    let shouldForwardPropOption = shouldForwardProp;

    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    if (componentSlot === 'Root' || componentSlot === 'root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag(tag)) {
      // for string (html) tag, preserve the behavior in emotion & styled-components.
      shouldForwardPropOption = undefined;
    }
    const defaultStyledResolver = (0,styled_engine["default"])(tag, (0,esm_extends/* default */.Z)({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));
    const transformStyleArg = stylesArg => {
      // On the server Emotion doesn't use React.forwardRef for creating components, so the created
      // component stays as a function. This condition makes sure that we do not interpolate functions
      // which are basically components used as a selectors.
      if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0,deepmerge/* isPlainObject */.P)(stylesArg)) {
        return props => processStyleArg(stylesArg, (0,esm_extends/* default */.Z)({}, props, {
          theme: resolveTheme({
            theme: props.theme,
            defaultTheme,
            themeId
          })
        }));
      }
      return stylesArg;
    };
    const muiStyledResolver = (styleArg, ...expressions) => {
      let transformedStyleArg = transformStyleArg(styleArg);
      const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = resolveTheme((0,esm_extends/* default */.Z)({}, props, {
            defaultTheme,
            themeId
          }));
          if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) {
            return null;
          }
          const styleOverrides = theme.components[componentName].styleOverrides;
          const resolvedStyleOverrides = {};
          // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
          Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
            resolvedStyleOverrides[slotKey] = processStyleArg(slotStyle, (0,esm_extends/* default */.Z)({}, props, {
              theme
            }));
          });
          return overridesResolver(props, resolvedStyleOverrides);
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push(props => {
          var _theme$components;
          const theme = resolveTheme((0,esm_extends/* default */.Z)({}, props, {
            defaultTheme,
            themeId
          }));
          const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
          return processStyleArg({
            variants: themeVariants
          }, (0,esm_extends/* default */.Z)({}, props, {
            theme
          }));
        });
      }
      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }
      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill('');
        // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      }
      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
      if (false) {}
      if (tag.muiName) {
        Component.muiName = tag.muiName;
      }
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
}
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/styled.js

const styled = createStyled();
/* harmony default export */ var esm_styled = (styled);

/***/ }),

/***/ 48540:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-services/[segment]",
      function () {
        return __webpack_require__(70641);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getSegmentationBreadcrumbs; },
/* harmony export */   "s": function() { return /* binding */ GET_SEGMENTATION_BREADCRUMBS; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68806);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36630);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query getSEOSegmentationBreadcrumbs($seoSegmentId: ID!) {\n    getSEOSegmentationBreadcrumbs(seoSegmentId: $seoSegmentId) {\n      breadcrumbs {\n        content\n        url\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GET_SEGMENTATION_BREADCRUMBS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject());
var getSegmentationBreadcrumbs = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(client, variables) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .apolloClientQuery */ .M)(client, GET_SEGMENTATION_BREADCRUMBS, variables)
            ];
        });
    });
    return function getSegmentationBreadcrumbs(client, variables) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 36630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ apolloClientQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);



var apolloClientQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(client, query, variables) {
        var ref, queryResponse, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        client.query({
                            query: query,
                            variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, variables),
                            errorPolicy: "all"
                        })
                    ];
                case 1:
                    queryResponse = _state.sent();
                    if (queryResponse.errors && ((ref = queryResponse.errors) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                        throw new Error(queryResponse.errors[0].message);
                    }
                    return [
                        2,
                        {
                            queryResponse: queryResponse,
                            error: null
                        }
                    ];
                case 2:
                    err = _state.sent();
                    return [
                        2,
                        {
                            queryResponse: null,
                            error: err
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function apolloClientQuery(client, query, variables) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 22284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12963);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);


var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs;
    var schemaJson = {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: []
    };
    var formatJSON = function(breadcrumb, index) {
        return {
            "@type": "ListItem",
            position: index + 1,
            item: {
                "@id": "".concat(breadcrumb.url),
                name: "".concat(breadcrumb.content)
            }
        };
    };
    var createBreadcrumbSchema = function() {
        schemaJson.itemListElement = breadcrumbs.map(function(breadcrumb, index) {
            return formatJSON(breadcrumb, index);
        }) || [];
        return schemaJson;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: breadcrumbs.map(function(param, index) {
                    var content = param.content, url = param.url;
                    return index + 1 !== breadcrumbs.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        component: "a",
                        href: url,
                        variant: "body2",
                        children: content
                    }, content) || index + 1 === breadcrumbs.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        role: "heading",
                        variant: "body2",
                        children: content
                    }, content);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                "data-testid": "breadcrumbListSchema",
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(createBreadcrumbSchema())
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumbs);


/***/ }),

/***/ 8410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _care_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29414);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);




var ref = next_config__WEBPACK_IMPORTED_MODULE_1___default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var SeoGlobalNavbar = function(param) {
    var enrollmentURL = param.enrollmentURL, _internalLinkingMenuContent = param.internalLinkingMenuContent, internalLinkingMenuContent = _internalLinkingMenuContent === void 0 ? undefined : _internalLinkingMenuContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_navigation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        baseURL: NEXT_PUBLIC_APP_URL,
        findJobURL: "/app/vhp/vertical-triage?memberType=sitter",
        logAnalyticsEvent: _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .logOrEnqueueEvent */ .sw,
        joinNowURL: enrollmentURL,
        internalLinkingMenu: {
            internalLinkingMenu: true,
            internalLinkingMenuContent: internalLinkingMenuContent
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoGlobalNavbar);


/***/ }),

/***/ 883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sj": function() { return /* binding */ AmplitudeEvent; },
/* harmony export */   "UP": function() { return /* binding */ setPagePropertiesFromData; },
/* harmony export */   "rG": function() { return /* binding */ trackAmplitudeEvent; },
/* harmony export */   "sw": function() { return /* binding */ logOrEnqueueEvent; },
/* harmony export */   "xF": function() { return /* binding */ setDeviceDataFromHeaders; }
/* harmony export */ });
/* unused harmony exports WebPlatform, AMPLITUDE_DATE_FORMAT, AMPLITUDE_TIME_FORMAT, AnalyticsHelper, enqueEvent */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _care_amplitude__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91649);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65885);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);








var WebPlatform;
(function(WebPlatform) {
    WebPlatform["MW"] = "Mobile Web";
    WebPlatform["DT"] = "Desktop Web";
})(WebPlatform || (WebPlatform = {}));
var AmplitudeEvent;
(function(AmplitudeEvent) {
    AmplitudeEvent["applySegmentationFilter"] = "Apply Segmentation Filter";
    AmplitudeEvent["clickOnSegmentationFilter"] = "Click on Segmentation Filter";
    AmplitudeEvent["ctaInteracted"] = "CTA Interacted";
    AmplitudeEvent["providerProfileViewed"] = "Provider Profile Viewed";
    AmplitudeEvent["monetateAssetClicked"] = "Monetate Asset Clicked";
    AmplitudeEvent["seoPageViewed"] = "SEO Page Viewed";
    AmplitudeEvent["testExposure"] = "Test Exposure";
    AmplitudeEvent["jobViewed"] = "Job Viewed";
    AmplitudeEvent["seoFeatureInteracted"] = "SEO Feature Interacted";
    AmplitudeEvent["errorViewed"] = "Error Viewed";
})(AmplitudeEvent || (AmplitudeEvent = {}));
var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()().publicRuntimeConfig;
var AMPLITUDE_DATE_FORMAT = "MMDDYYYY";
var AMPLITUDE_TIME_FORMAT = "hh:mm A";
var initialized = false;
var AnalyticsHelper = /*#__PURE__*/ function() {
    "use strict";
    function AnalyticsHelper() {
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, AnalyticsHelper);
        this.amplitudeEventsQueue = [];
        this.setHeaderData = function(data) {
            _this.headerData = data;
        };
        this.setPageProperties = function(properties) {
            _this.pageProperties = properties;
        };
        this.getHeaderData = function() {
            return _this.headerData;
        };
        this.setEventInQueue = function(event) {
            // @ts-ignore FIX: event is of never type
            _this.amplitudeEventsQueue.push(event);
        };
        this.getEventFromQueue = function() {
            return _this.amplitudeEventsQueue.shift();
        };
        this.getCommonData = function() {
            var cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z();
            var ref = _this.headerData || {}, deviceOs = ref.device_os, isMobile = ref.is_mobile, mobileBrowser = ref.mobile_browser, mobileBrowserVersion = ref.mobile_browser_version;
            var ref1 = _this.pageProperties || {}, seoPageId = ref1.seo_page_id, screenName = ref1.screen_name, screenTemplate = ref1.screen_template, ServiceIdForMember = ref1.service_id_for_member, slots = ref1.slots;
            var czenVisitorId = cookies.get(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CZEN_VISITOR_COOKIE_KEY */ .iN);
            var czenSessionId = cookies.get(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CZEN_SESSION_COOKIE_KEY */ .Ih);
            var screenResolution = "".concat(window.screen.width, " x ").concat(window.screen.height);
            var viewportResolution = "".concat(window.innerWidth, " x ").concat(window.innerHeight);
            var visitorId = czenVisitorId || "VisitorIdNotFound";
            var CZENSessionId = czenSessionId || "SessionIdNotFound";
            var deviceModel = (deviceOs === null || deviceOs === void 0 ? void 0 : deviceOs.split(" ").length) > 1 ? deviceOs === null || deviceOs === void 0 ? void 0 : deviceOs.split(" ")[0] : deviceOs;
            var webPlatform = isMobile === "true" ? WebPlatform.MW : WebPlatform.DT;
            var commonData = {
                czen_session_id: CZENSessionId,
                device_model: deviceModel,
                environment: publicRuntimeConfig.SENTRY_ENV,
                language: navigator.language,
                os_name: mobileBrowser,
                os_version: mobileBrowserVersion,
                referer: document.referrer,
                rendered_by: "seo-mfe",
                screen_name: screenName,
                screen_resolution: screenResolution,
                screen_template: screenTemplate,
                seo_page_id: seoPageId,
                service_id_for_member: ServiceIdForMember,
                slots: slots,
                userAgent: navigator.userAgent,
                viewport_resolution: viewportResolution,
                visitor_id: visitorId,
                web_platform: webPlatform
            };
            return commonData;
        };
        this.logEvent = function(payload) {
            try {
                if (!initialized) {
                    var careAnalyticsConfig = {
                        analyticsEnabled: publicRuntimeConfig.ANALYTICS_ENABLED === "true",
                        key: publicRuntimeConfig.AMPLITUDE_API_KEY,
                        commonData: _this.getCommonData()
                    };
                    (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .init */ .S1)(careAnalyticsConfig);
                    initialized = true;
                    // session id is available with a small delay after amplitude initialization
                    setTimeout(function() {
                        var ref;
                        var amplitudeSessionId = (ref = (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .getInstance */ .s8)()) === null || ref === void 0 ? void 0 : ref.getSessionId();
                        if (amplitudeSessionId) {
                            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .configureScope */ .e)(function(scope) {
                                var user = scope.getUser();
                                scope.setUser((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, user), {
                                    amplitudeSessionId: amplitudeSessionId
                                }));
                            });
                        }
                    });
                }
                var logEventPayload = {
                    name: payload.name,
                    data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload.data)
                };
                (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .logEvent */ .Kz)(logEventPayload);
            } catch (e) {
                (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb)(e);
            }
        };
    }
    AnalyticsHelper.init = function init() {
        if (this.analytics === undefined) {
            this.analytics = new AnalyticsHelper();
        }
        return this.analytics;
    };
    return AnalyticsHelper;
}();
var enqueEvent = function(event) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance.setEventInQueue(event);
    return event;
};
var dequeEvent = function() {
    var analyticsInstance = AnalyticsHelper.init();
    return analyticsInstance.getEventFromQueue();
};
var logOrEnqueueEvent = function(param) {
    var name = param.name, data = param.data;
    if (!name || !data) return null;
    var analyticsInstance = AnalyticsHelper.init();
    if (analyticsInstance.getHeaderData() === undefined) {
        return enqueEvent({
            name: name,
            data: data
        });
    }
    return analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.logEvent({
        data: data,
        name: name
    });
};
var trackAmplitudeEvent = function() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    logOrEnqueueEvent({
        name: name,
        data: data
    });
};
var setPagePropertiesFromData = function(properties) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.setPageProperties(properties);
};
var setDeviceDataFromHeaders = function(data) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.setHeaderData(data);
    var eventsPresentInQueue = analyticsInstance.amplitudeEventsQueue.length;
    if (eventsPresentInQueue > 0) {
        // eslint-disable-next-line no-plusplus
        for(var i = 0; i < eventsPresentInQueue; i++){
            var ref = dequeEvent(), eventName = ref.name, eventData = ref.data;
            trackAmplitudeEvent(eventName, eventData);
        }
        return eventsPresentInQueue;
    }
    return data;
};


/***/ }),

/***/ 70641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ renderServicesListByCityOrState; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/lib/ApolloClient.ts + 75 modules
var ApolloClient = __webpack_require__(77414);
// EXTERNAL MODULE: ./src/utils/getDeviceCharacteristics.ts
var getDeviceCharacteristics = __webpack_require__(93867);
// EXTERNAL MODULE: ./src/utils/reqHeaderToEntriesObj.ts
var reqHeaderToEntriesObj = __webpack_require__(28906);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(68806);
// EXTERNAL MODULE: ./src/API/utils.ts
var utils = __webpack_require__(36630);
;// CONCATENATED MODULE: ./src/API/seoSegmentationsByCityOrState.ts



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query seoSegmentationsByCityOrState($seoSegmentId: ID!) {\n    seoSegmentationsByCityOrState(seoSegmentId: $seoSegmentId) {\n      __typename\n      ... on SEOSegmentationsByCityOrStateSuccess {\n        seoSegmentationsByCityOrState {\n          city\n          linkSection {\n            section {\n              linkList {\n                content\n                url\n              }\n              subSectionId\n              subSectionTitle {\n                ... on SEOLinkSectionTitle {\n                  title\n                }\n                ... on SEOLinkSectionLinkedTitle {\n                  linkedTitle {\n                    content\n                    url\n                  }\n                }\n              }\n            }\n            sectionId\n          }\n          state\n        }\n      }\n      ... on SEOSegmentationsByCityOrStateError {\n        error {\n          message\n          ... on DataNotAvailableError {\n            message\n          }\n          ... on UrlNotFoundError {\n            message\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var SEO_SEGMENTATIONS_BY_CITY_OR_STATE = (0,lib/* default */.ZP)(_templateObject());
var seoSegmentationsByCityOrState_seoSegmentationsByCityOrState = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(client, log, variables) {
        var ref, queryResponse, error, data, errors, responseError, _error, errorMessage, segmentationsList;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,utils/* apolloClientQuery */.M)(client, SEO_SEGMENTATIONS_BY_CITY_OR_STATE, variables)
                    ];
                case 1:
                    ref = _state.sent(), queryResponse = ref.queryResponse, error = ref.error;
                    // unknown error
                    if (error) {
                        return [
                            2,
                            {
                                seoSegmentationsByCityOrState: null,
                                error: error
                            }
                        ];
                    }
                    data = queryResponse.data, errors = queryResponse.errors, responseError = queryResponse.error;
                    // GraphQL errors that occur while processing a GraphQL operation (resulting in built-in error codes such as INTERNAL_SERVER_ERROR)
                    if (errors && errors.length > 0) {
                        return [
                            2,
                            {
                                seoSegmentationsByCityOrState: null,
                                error: errors
                            }
                        ];
                    }
                    // Coverage for 'error' property in queryResponse
                    if (responseError) {
                        return [
                            2,
                            {
                                seoSegmentationsByCityOrState: null,
                                error: responseError
                            }
                        ];
                    }
                    // known error
                    if (data.seoSegmentationsByCityOrState.__typename === "SEOSegmentationsByCityOrStateError") {
                        _error = data.seoSegmentationsByCityOrState.error, errorMessage = _error.message;
                        log.error("[GraphQL error]: ".concat(errorMessage));
                        return [
                            2,
                            {
                                seoSegmentationsByCityOrState: null,
                                error: data.seoSegmentationsByCityOrState.error
                            }
                        ];
                    }
                    segmentationsList = data.seoSegmentationsByCityOrState.seoSegmentationsByCityOrState;
                    return [
                        2,
                        {
                            seoSegmentationsByCityOrState: segmentationsList,
                            error: null
                        }
                    ];
            }
        });
    });
    return function seoSegmentationsByCityOrState(client, log, variables) {
        return _ref.apply(this, arguments);
    };
}();


// EXTERNAL MODULE: ./src/API/getSegmentationBreadcrumbs.ts
var getSegmentationBreadcrumbs = __webpack_require__(35149);
;// CONCATENATED MODULE: ./src/components/pages/directories/CityServices/cityServicesDirectoryProps.ts









var getServerSideProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var query, req, res, ref, ref1, startPageGSSP, apolloOptions, startApolloClient, apolloClient, stopApolloClient, isLocal, userAgent, deviceCharHeader, deviceChar, segment, seoSegmentId, startGetPageData, ref2, seoSegmentationsByCityOrStateResponse, getSegmentationBreadcrumbsResponse, stopGetPageData, seoSegmentationsByCityOrState, error, pageData, pageProps, stopPageGSSP;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = param.query, req = param.req, res = param.res;
                    startPageGSSP = performance.now();
                    apolloOptions = {
                        logError: req.log.error.bind(req.log),
                        logInfo: req.log.info.bind(req.log)
                    };
                    startApolloClient = performance.now();
                    apolloClient = (0,ApolloClient/* getApolloClient */.W)(apolloOptions);
                    stopApolloClient = performance.now();
                    isLocal = "production" === "development";
                    userAgent = req.headers["user-agent"] || "";
                    deviceCharHeader = ((ref = req.headers["x-akamai-device-characteristics"]) === null || ref === void 0 ? void 0 : ref.toString()) || "";
                    deviceChar = isLocal ? (0,getDeviceCharacteristics/* default */.Z)(userAgent, deviceCharHeader) : (0,reqHeaderToEntriesObj/* default */.Z)(deviceCharHeader, ";");
                    segment = query.segment;
                    seoSegmentId = "/all-services/".concat(segment);
                    startGetPageData = performance.now();
                    return [
                        4,
                        Promise.all([
                            seoSegmentationsByCityOrState_seoSegmentationsByCityOrState(apolloClient, req.log, {
                                seoSegmentId: seoSegmentId
                            }),
                            (0,getSegmentationBreadcrumbs/* getSegmentationBreadcrumbs */.V)(apolloClient, {
                                seoSegmentId: seoSegmentId
                            })
                        ])
                    ];
                case 1:
                    ref2 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), seoSegmentationsByCityOrStateResponse = ref2[0], getSegmentationBreadcrumbsResponse = ref2[1];
                    stopGetPageData = performance.now();
                    seoSegmentationsByCityOrState = seoSegmentationsByCityOrStateResponse.seoSegmentationsByCityOrState, error = seoSegmentationsByCityOrStateResponse.error;
                    if (seoSegmentationsByCityOrState === null && error) {
                        req.log.error({
                            event: "cityServicesDirectoryLoadError",
                            seoSegmentId: seoSegmentId,
                            userAgent: userAgent,
                            deviceChar: deviceChar,
                            query: query,
                            res: res,
                            error: error
                        });
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    pageData = (0,_object_spread/* default */.Z)({}, seoSegmentationsByCityOrState, (ref1 = getSegmentationBreadcrumbsResponse.queryResponse) === null || ref1 === void 0 ? void 0 : ref1.data.getSEOSegmentationBreadcrumbs);
                    pageProps = {
                        props: {
                            pageData: pageData,
                            seoSegmentId: seoSegmentId,
                            deviceChar: deviceChar
                        }
                    };
                    req.log.info({
                        event: "cityServicesDirectoryLoadSuccess",
                        seoSegmentId: seoSegmentId,
                        userAgent: userAgent,
                        deviceChar: deviceChar,
                        query: query,
                        res: res
                    });
                    stopPageGSSP = performance.now();
                    req.careContext.serverTimings.pageGSSP = stopPageGSSP - startPageGSSP;
                    req.careContext.serverTimings.apolloClient = stopApolloClient - startApolloClient;
                    req.careContext.serverTimings.pageData = stopGetPageData - startGetPageData;
                    return [
                        2,
                        pageProps
                    ];
            }
        });
    });
    return function getServerSideProps(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/pages/directories/StateServices/stateServicesDirectoryProps.ts








var stateServicesDirectoryProps_getServerSideProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var query, req, res, ref, ref1, startPageGSSP, apolloOptions, startApolloClient, apolloClient, stopApolloClient, isLocal, userAgent, botInfo, deviceCharHeader, deviceChar, segment, seoSegmentId, startGetPageData, ref2, seoSegmentationsByCityOrStateResponse, stopGetPageData, seoSegmentationsByCityOrState, error, pageData, pageProps, stopPageGSSP;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = param.query, req = param.req, res = param.res;
                    startPageGSSP = performance.now();
                    apolloOptions = {
                        logError: req.log.error.bind(req.log),
                        logInfo: req.log.info.bind(req.log)
                    };
                    startApolloClient = performance.now();
                    apolloClient = (0,ApolloClient/* getApolloClient */.W)(apolloOptions);
                    stopApolloClient = performance.now();
                    isLocal = "production" === "development";
                    userAgent = req.headers["user-agent"] || "";
                    botInfo = ((ref = req.headers["Akamai-Bot"]) === null || ref === void 0 ? void 0 : ref.toString()) || "";
                    deviceCharHeader = ((ref1 = req.headers["x-akamai-device-characteristics"]) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "";
                    deviceChar = isLocal ? (0,getDeviceCharacteristics/* default */.Z)(userAgent, deviceCharHeader) : (0,reqHeaderToEntriesObj/* default */.Z)(deviceCharHeader, ";");
                    segment = query.segment;
                    seoSegmentId = "/all-services/".concat(segment);
                    startGetPageData = performance.now();
                    return [
                        4,
                        Promise.all([
                            seoSegmentationsByCityOrState_seoSegmentationsByCityOrState(apolloClient, req.log, {
                                seoSegmentId: seoSegmentId
                            })
                        ])
                    ];
                case 1:
                    ref2 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        1
                    ]), seoSegmentationsByCityOrStateResponse = ref2[0];
                    stopGetPageData = performance.now();
                    seoSegmentationsByCityOrState = seoSegmentationsByCityOrStateResponse.seoSegmentationsByCityOrState, error = seoSegmentationsByCityOrStateResponse.error;
                    if (seoSegmentationsByCityOrState === null && error) {
                        req.log.error({
                            event: "stateServicesDirectoryLoadError",
                            seoSegmentId: seoSegmentId,
                            userAgent: userAgent,
                            deviceChar: deviceChar,
                            query: query,
                            res: res,
                            error: error,
                            botInfo: botInfo
                        });
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    pageData = (0,_object_spread/* default */.Z)({}, seoSegmentationsByCityOrState);
                    pageProps = {
                        props: {
                            pageData: pageData,
                            seoSegmentId: seoSegmentId,
                            deviceChar: deviceChar
                        }
                    };
                    req.log.info({
                        event: "stateServicesDirectoryLoadSuccess",
                        seoSegmentId: seoSegmentId,
                        userAgent: userAgent,
                        deviceChar: deviceChar,
                        query: query,
                        res: res,
                        botInfo: botInfo
                    });
                    stopPageGSSP = performance.now();
                    req.careContext.serverTimings.pageGSSP = stopPageGSSP - startPageGSSP;
                    req.careContext.serverTimings.apolloClient = stopApolloClient - startApolloClient;
                    req.careContext.serverTimings.pageData = stopGetPageData - startGetPageData;
                    return [
                        2,
                        pageProps
                    ];
            }
        });
    });
    return function getServerSideProps(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash-es/cloneDeepWith.js + 30 modules
var cloneDeepWith = __webpack_require__(23337);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/CoreGlobalFooter/CoreGlobalFooter.js + 8 modules
var CoreGlobalFooter = __webpack_require__(69388);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
// EXTERNAL MODULE: ./src/components/SeoGlobalNavbar.tsx
var SeoGlobalNavbar = __webpack_require__(8410);
// EXTERNAL MODULE: ./src/utils/columnarLinkedList.ts
var columnarLinkedList = __webpack_require__(12806);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/components/Breadcrumbs.tsx
var Breadcrumbs = __webpack_require__(22284);
;// CONCATENATED MODULE: ./src/components/pages/directories/CityServices/CityServicesDirectory.tsx














var CityServicesDirectory = function(param) {
    var props = param.props;
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var numOfColumns = isMobile ? 1 : 3;
    var _pageData = props.pageData, linkSection = _pageData.linkSection, city = _pageData.city, state = _pageData.state, breadcrumbs = _pageData.breadcrumbs;
    var deviceChar = props.deviceChar;
    var stringifyDeviceChar = JSON.stringify(deviceChar);
    var trackPageViewedEvent = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var amplitudeDataForPageViewed;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        amplitudeDataForPageViewed = {
                            screen_name: "SEO Directory Page",
                            seo_page_title: "Browse Care.com Local Services in ".concat(city, ", ").concat(state),
                            seo_page_type: "SEO Directory page",
                            page_template: "City Services Directory",
                            seo_page_id: 1443
                        };
                        return [
                            4,
                            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoPageViewed */.Sj.seoPageViewed, amplitudeDataForPageViewed)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function trackPageViewedEvent() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        trackPageViewedEvent();
    });
    (0,react.useEffect)(function() {
        if (deviceChar && Object.keys(deviceChar).length > 0) {
            (0,analyticsHelper/* setDeviceDataFromHeaders */.xF)(deviceChar);
        }
    }, [
        stringifyDeviceChar,
        deviceChar
    ]);
    var subSectionLinkList = function(linkList) {
        return linkList.map(function(link) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                pb: 1.25,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    variant: "link2",
                    href: link.url,
                    sx: {
                        ":hover": {
                            textDecoration: "none"
                        }
                    },
                    children: link.content
                })
            }, link.content);
        });
    };
    var renderSubSection = function(section) {
        return section.map(function(param) {
            var subSectionId = param.subSectionId, subSectionTitle = param.subSectionTitle, linkList = param.linkList;
            var segmentationList = subSectionLinkList(linkList);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                width: "300px",
                mr: {
                    sm: 3,
                    md: 6,
                    lg: 10
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        pb: 1.25,
                        children: [
                            subSectionTitle.__typename === "SEOLinkSectionTitle" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                children: subSectionTitle.title
                            }),
                            subSectionTitle.__typename === "SEOLinkSectionLinkedTitle" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                variant: "h3",
                                href: subSectionTitle.linkedTitle.url,
                                sx: {
                                    ":hover": {
                                        textDecoration: "none"
                                    }
                                },
                                children: subSectionTitle.linkedTitle.content
                            }, subSectionTitle.linkedTitle.content)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        display: "flex",
                        flexDirection: "column",
                        children: segmentationList
                    })
                ]
            }, subSectionId);
        });
    };
    var sortSubSection = function(section) {
        var _obj;
        var sortOrder = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.BABYSITTERS */.rp.BABYSITTERS, 1), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.NANNY */.rp.NANNY, 2), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.PET_CARE */.rp.PET_CARE, 3), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.CHILD_CARE */.rp.CHILD_CARE, 4), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.SENIOR_CARE */.rp.SENIOR_CARE, 5), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.TUTORS */.rp.TUTORS, 6), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.HOUSE_KEEPING */.rp.HOUSE_KEEPING, 7), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.CARE_GIGS */.rp.CARE_GIGS, 8), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.SPECIAL_NEEDS */.rp.SPECIAL_NEEDS, 9), _obj);
        return (0,cloneDeepWith/* default */.Z)(section).sort(function(subSectionA, subSectionB) {
            return sortOrder[subSectionA.subSectionId] - sortOrder[subSectionB.subSectionId];
        });
    };
    var segmentationsDirectory = linkSection.map(function(param) {
        var sectionId = param.sectionId, section = param.section;
        var subSections = section.filter(function(subSection) {
            return subSection.linkList.length > 0;
        });
        var columnarSubSections = (0,columnarLinkedList/* default */.Z)(subSections, numOfColumns);
        if (sectionId === constants/* DirectorySection.PROVIDERS */.rH.PROVIDERS) {
            subSections = sortSubSection(subSections);
        }
        var renderSubSections = columnarSubSections.map(function(subSectionRow, index) {
            var directorySubSection = renderSubSection(subSectionRow);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "flex",
                flexDirection: {
                    xs: "column",
                    sm: "row"
                },
                mb: 6.25,
                children: directorySubSection
            }, "row-".concat(index + 1));
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: renderSubSections
        }, sectionId);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            "Browse Local Services in ".concat(city, ", ").concat(state, " | Care.com"),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Find ".concat(city, ", ").concat(state, " services on Care.com")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoGlobalNavbar/* default */.Z, {
                enrollmentURL: "/app/vhp/get-started"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mt: 5,
                                mb: 3,
                                children: breadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                                    breadcrumbs: breadcrumbs
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mb: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h2",
                                    component: "h1",
                                    children: "Browse Care.com Local Services in ".concat(city, ", ").concat(state)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: segmentationsDirectory
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGlobalFooter/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var CityServices_CityServicesDirectory = (CityServicesDirectory);

;// CONCATENATED MODULE: ./src/components/pages/directories/StateServices/StateServicesDirectory.tsx














var StateServicesDirectory = function(param) {
    var props = param.props;
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var isSmallViewPort = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.only("sm");
    });
    var numOfSubSectionsPerColumns = isMobile ? 1 : 3;
    var _pageData = props.pageData, linkSection = _pageData.linkSection, state = _pageData.state;
    var deviceChar = props.deviceChar;
    var stringifyDeviceChar = JSON.stringify(deviceChar);
    var trackPageViewedEvent = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var amplitudeDataForPageViewed;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        amplitudeDataForPageViewed = {
                            screen_name: "SEO Directory Page",
                            seo_page_title: "Browse Care.com Local Services in ".concat(constants/* mapStateCodeToFullName */.Q5[state]),
                            seo_page_type: "SEO Directory page",
                            page_template: "State Services Directory",
                            seo_page_id: 1443
                        };
                        return [
                            4,
                            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoPageViewed */.Sj.seoPageViewed, amplitudeDataForPageViewed)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function trackPageViewedEvent() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        trackPageViewedEvent();
    });
    (0,react.useEffect)(function() {
        if (deviceChar && Object.keys(deviceChar).length > 0) {
            (0,analyticsHelper/* setDeviceDataFromHeaders */.xF)(deviceChar);
        }
    }, [
        stringifyDeviceChar,
        deviceChar
    ]);
    var subSectionLinkList = function(linkList) {
        return linkList.map(function(link) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                pb: 1.25,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    variant: "link2",
                    href: link.url,
                    sx: {
                        ":hover": {
                            textDecoration: "none"
                        }
                    },
                    children: link.content
                })
            }, link.content);
        });
    };
    var renderSubSection = function(section) {
        return section.map(function(param) {
            var subSectionId = param.subSectionId, subSectionTitle = param.subSectionTitle, linkList = param.linkList;
            var segmentationList = subSectionLinkList(linkList);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                width: "300px",
                mr: {
                    sm: 3,
                    md: 6,
                    lg: 10
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        pb: 1.25,
                        children: [
                            subSectionTitle.__typename === "SEOLinkSectionTitle" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                children: subSectionTitle.title
                            }),
                            subSectionTitle.__typename === "SEOLinkSectionLinkedTitle" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                variant: "h3",
                                href: subSectionTitle.linkedTitle.url,
                                sx: {
                                    ":hover": {
                                        textDecoration: "none"
                                    }
                                },
                                children: subSectionTitle.linkedTitle.content
                            }, subSectionTitle.linkedTitle.content)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        display: "flex",
                        flexDirection: "column",
                        children: segmentationList
                    })
                ]
            }, subSectionId);
        });
    };
    var renderCityList = function(section) {
        var subSections = section.map(function(param) {
            var subSectionTitle = param.subSectionTitle;
            if (subSectionTitle.__typename === "SEOLinkSectionTitle") {
                var title = subSectionTitle.title;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    width: "200px",
                    mr: {
                        sm: 3,
                        md: 6,
                        lg: 10
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        pb: 1.25,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "link2",
                            children: title
                        })
                    })
                }, title);
            }
            var _linkedTitle = subSectionTitle.linkedTitle, content = _linkedTitle.content, url = _linkedTitle.url;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                width: "200px",
                mr: {
                    sm: 3,
                    md: 6,
                    lg: 10
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    pb: 1.25,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        variant: "link2",
                        href: url,
                        sx: {
                            ":hover": {
                                textDecoration: "none"
                            }
                        },
                        children: content
                    })
                })
            }, content);
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            display: "flex",
            flexDirection: "column",
            children: subSections
        });
    };
    var sortSubSection = function(section) {
        var _obj;
        var subSectionOrder = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.BABYSITTERS */.rp.BABYSITTERS, 1), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.NANNY */.rp.NANNY, 2), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.PET_CARE */.rp.PET_CARE, 3), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.CHILD_CARE */.rp.CHILD_CARE, 4), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.SENIOR_CARE */.rp.SENIOR_CARE, 5), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.TUTORS */.rp.TUTORS, 6), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.HOUSE_KEEPING */.rp.HOUSE_KEEPING, 7), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.CARE_GIGS */.rp.CARE_GIGS, 8), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySubSections.SPECIAL_NEEDS */.rp.SPECIAL_NEEDS, 9), _obj);
        return (0,cloneDeepWith/* default */.Z)(section).sort(function(subSectionA, subSectionB) {
            return subSectionOrder[subSectionA.subSectionId] - subSectionOrder[subSectionB.subSectionId];
        });
    };
    var sortSection = function(section) {
        var _obj;
        var sectionOrder = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* DirectorySection.SEGMENTATION_STATE */.rH.SEGMENTATION_STATE, 1), (0,_define_property/* default */.Z)(_obj, constants/* DirectorySection.ALL_SERVICES_CITY */.rH.ALL_SERVICES_CITY, 2), _obj);
        return (0,cloneDeepWith/* default */.Z)(section).sort(function(sectionA, sectionB) {
            return sectionOrder[sectionA.sectionId] - sectionOrder[sectionB.sectionId];
        });
    };
    var renderServicesList = function(directorySection) {
        var sectionId = directorySection.sectionId, section = directorySection.section;
        var subSections = section.filter(function(subSection) {
            return subSection.linkList.length > 0;
        });
        var sortedSubSections = sortSubSection(subSections);
        var columnizeSubSections = (0,columnarLinkedList/* default */.Z)(sortedSubSections, numOfSubSectionsPerColumns);
        var renderSubSections = columnizeSubSections.map(function(subSectionRow, index) {
            var directorySubSection = renderSubSection(subSectionRow);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "flex",
                flexDirection: {
                    xs: "column",
                    sm: "row"
                },
                mb: 4.5,
                children: directorySubSection
            }, "service-row-".concat(index + 1));
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: renderSubSections
        }, sectionId);
    };
    var ref = (0,_sliced_to_array/* default */.Z)(sortSection(linkSection).map(function(directorySection) {
        if (directorySection.sectionId === constants/* DirectorySection.SEGMENTATION_STATE */.rH.SEGMENTATION_STATE) {
            return renderServicesList(directorySection);
        }
        var section = directorySection.section, sectionId = directorySection.sectionId;
        // eslint-disable-next-line no-nested-ternary
        var numOfCitiesPerColumns = isMobile ? 1 : isSmallViewPort ? Math.ceil(section.length / 3) : Math.ceil(section.length / 4);
        var columnizeSubSections = (0,columnarLinkedList/* default */.Z)(section, numOfCitiesPerColumns);
        var renderSubSections = columnizeSubSections.map(function(subSectionRow, index) {
            var directorySubSection = renderCityList(subSectionRow);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "flex",
                flexDirection: {
                    xs: "column",
                    sm: "row"
                },
                children: directorySubSection
            }, "city-column-".concat(index + 1));
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            display: "flex",
            flexDirection: {
                xs: "column",
                sm: "row"
            },
            mb: 11.625,
            children: renderSubSections
        }, sectionId);
    }), 2), servicesList = ref[0], cityList = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            "Browse Local Services in ".concat(state, " - Care.com"),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Find all Care.com services in ".concat(constants/* mapStateCodeToFullName */.Q5[state])
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoGlobalNavbar/* default */.Z, {
                enrollmentURL: "/app/vhp/get-started"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mt: 2,
                                mb: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h2",
                                    component: "h1",
                                    children: "Browse Care.com Local Services in ".concat(constants/* mapStateCodeToFullName */.Q5[state])
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: servicesList
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mb: 3.5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h2",
                                    component: "h2",
                                    children: "Browse all services in ".concat(constants/* mapStateCodeToFullName */.Q5[state], " by city")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sx: {
                                textTransform: "capitalize"
                            },
                            children: cityList
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGlobalFooter/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var StateServices_StateServicesDirectory = (StateServicesDirectory);

;// CONCATENATED MODULE: ./src/components/pages/directories/StateServices/index.tsx







var StateServices_getServerSideProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
        var ref, getDataFn;
        return (0,tslib_es6.__generator)(this, function(_state) {
            getDataFn = ((ref = context.query.segment) === null || ref === void 0 ? void 0 : ref.includes("-")) ? getServerSideProps : stateServicesDirectoryProps_getServerSideProps;
            return [
                2,
                getDataFn(context)
            ];
        });
    });
    return function getServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();
function renderServicesListByCityOrState(pageProps) {
    var seoSegmentId = pageProps.seoSegmentId;
    // split to check the last element in the array is ${city}-${state} or ${state} format:
    // e.g. ['', 'all-services', 'austin-tx'] or ['', 'all-services', 'tx']
    var segments = seoSegmentId.split("/");
    if (segments[2].includes("-")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CityServices_CityServicesDirectory, {
            props: pageProps
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StateServices_StateServicesDirectory, {
        props: pageProps
    });
}

;// CONCATENATED MODULE: ./src/pages/all-services/[segment].tsx
var __N_SSP = true;



/***/ }),

/***/ 12806:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function columnarLinkedList(linkList) {
    var numOfColumns = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (numOfColumns < 1) throw new Error("Number of columns must be greater than 0!");
    return linkList.reduce(function(resultArray, item, index) {
        var chunkIndex = Math.floor(index / numOfColumns);
        var resultArrayCopy = resultArray;
        if (!resultArrayCopy[chunkIndex]) {
            resultArrayCopy[chunkIndex] = new Array(); // start a new chunk
        }
        resultArrayCopy[chunkIndex].push(item);
        return resultArrayCopy;
    }, []);
}
/* harmony default export */ __webpack_exports__["Z"] = (columnarLinkedList);


/***/ }),

/***/ 93867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _reqHeaderToEntriesObj__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28906);

var getDeviceCharacteristics = function(userAgent, deviceCharHeader) {
    var deviceChar = (0,_reqHeaderToEntriesObj__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(deviceCharHeader, ";");
    if (Object.keys(deviceChar).length === 0) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
            deviceChar = {
                is_mobile: "true"
            };
        } else {
            deviceChar = {
                is_mobile: "false"
            };
        }
    }
    return deviceChar;
};
/* harmony default export */ __webpack_exports__["Z"] = (getDeviceCharacteristics);


/***/ }),

/***/ 28906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/**
 * Transmutes a key/value pairs object into the format expected by GraphQLEnumType
 * @param  {string} header header string of keys and values
 * @param  {string} delimeter symbol used to separate each key value pair from the next pair
 * @param  {string} valueDelimeter symbol used to separate the key from its value within each pair
 * @return {Object}     Entries object (key/value pairs)
 */ 
var reqHeaderToEntriesObj = function(header) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ";", valueDelimeter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "=";
    if (header === "") return {};
    return header.split(delimiter).reduce(function(accum, curVal) {
        var obj = accum;
        var keyValuePair = curVal.split(valueDelimeter);
        var _keyValuePair = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(keyValuePair, 2), keyValuePairKey = _keyValuePair[0], keyValuePairValue = _keyValuePair[1];
        obj[keyValuePairKey] = keyValuePairValue;
        return obj;
    }, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (reqHeaderToEntriesObj);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2453,898,9417,1207,1136,9774,2888,179], function() { return __webpack_exec__(48540); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);